<template lang='pug'>
  .checkout-container.u-pbl
    router-view
    modals-container(:key="$route.fullPath")
</template>

<script>
  export default {
    name: 'CheckoutIndex'
  };
</script>
